import { Dialog_VariableEditor, ModuleFE_HCSPermissions, Preview_Variable } from '@app/hcs-frontend';
import { AccessLevel } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
export const noDiseaseViewId = '###No-View###';
export const profileEditor_OpenVariable = (variable) => {
    if (!variable)
        return;
    if (ModuleFE_HCSPermissions.permissions.collection.edit.getAccessLevel() === AccessLevel.NoAccess)
        return Preview_Variable.show(variable._id);
    Dialog_VariableEditor.show('', variable);
};
//# sourceMappingURL=consts.js.map